import { client } from 'util/sdk';
import { GET, POST, DELETE } from 'util/api';
import { FSPS } from 'consts';

const returnModel = { name: 'fspinsightevent' };
const FSP_INSIGHT_EVENTS = 'fspinsightevents';

const loadURL = (fspId) => `/${FSPS}/${fspId}/${FSP_INSIGHT_EVENTS}`;
const removeOrUpdateURL = (fspId, id) => `${loadURL(fspId)}/${id}`;

export const load = (fspId) =>
  client.executeRequest(GET, loadURL(fspId), { returnModel });

export const update = ({ fspId, id, ...data }, auth) =>
  client.executeRequest(POST, removeOrUpdateURL(fspId, id), {
    data,
    queryParams: { adminUserId: auth.id },
    returnModel,
  });

export const create = ({ fspId, id, ...data }, auth) =>
  client.executeRequest(POST, loadURL(fspId), {
    data,
    queryParams: { adminUserId: auth.id },
    returnModel,
  });

export const remove = ({ fspId, id }, auth) => {
  return client.executeRequest(DELETE, removeOrUpdateURL(fspId, id), {
    queryParams: { adminUserId: auth.id },
    returnModel,
  });
};
